(function () {
  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    if (!location.pathname.startsWith('/cart')) return;

    const modal = document.getElementById('ntech-pay-modal');
    if (!modal) return;

    // ===== offers
    function getOffer(totalCents) {
      if (totalCents >= 200000) return { saveEuros: 300, code: 'CASH300' };
      if (totalCents >= 160000) return { saveEuros: 200, code: 'CASH200' };
      if (totalCents >= 120000) return { saveEuros: 150, code: 'CASH150' };
      if (totalCents >= 80000)  return { saveEuros: 100, code: 'CASH100' };
      return null;
    }

    const totalCents = Number(window.NTECH_CART_TOTAL_CENTS || 0);
    const offer = getOffer(totalCents);

    const saveEl = document.getElementById('ntech-cash-save');
    if (saveEl) saveEl.textContent = offer ? `€${offer.saveEuros}` : 'à partir de 800€';

    // ===== modal open/close
    function openModal() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    }

    modal.addEventListener('click', function (e) {
      if (e.target && e.target.matches('[data-ntech-close]')) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });

    // ===== intercept checkout click (capture) -> show modal
    document.addEventListener('click', function (e) {
      const btn = e.target && e.target.closest
        ? e.target.closest('form[action*="/cart"] button[name="checkout"], button[name="checkout"]')
        : null;
      if (!btn) return;

      if (!location.pathname.startsWith('/cart')) return;

      e.preventDefault();
      e.stopPropagation();
      openModal();
    }, true);

    // ===== buttons inside modal
    const cashBtn = document.getElementById('ntech-pay-cash');
    const instBtn = document.getElementById('ntech-pay-installments');

    

    // CASH -> only at checkout
    if (cashBtn) {
      cashBtn.addEventListener('click', function () {
  // Si pas d'offre : on laisse payer comptant normalement (sans remise)
  if (!offer) {
    window.location.href = '/checkout';
    return;
  }
  // Sinon : checkout avec code
  window.location.href = `/checkout?discount=${encodeURIComponent(offer.code)}`;
});
    }

    // INSTALLMENTS -> go Partial.ly button/link
    function findPartiallyTarget() {
      const a =
        document.querySelector('a.partiallyButton[href*="partial.ly/checkout"]') ||
        document.querySelector('a[href*="partial.ly/checkout"]');
      if (a && a.href) return { type: 'href', el: a };

      const form = document.querySelector('form[action*="partial.ly/checkout"]');
      if (form) return { type: 'form', el: form };

      return null;
    }

    if (instBtn) {
      instBtn.addEventListener('click', function () {
        closeModal();

        const target = findPartiallyTarget();
        if (!target) {
          alert("Impossible d'ouvrir Partial.ly (bouton introuvable). Rafraîchissez et réessayez.");
          return;
        }
        if (target.type === 'href') window.location.href = target.el.href;
        else target.el.submit();
      });
    }
  });
})();